export const locationCandidatoParse = (location, f = []) => {
    const parseState = location ? location.state : null;

    if (parseState && parseState.candidato) {
        f = f.filter(f => f.field !== 'id');
        f.push({ field: 'id', value: parseState.candidato.id });
    }

    return f;
}

export const filterPersistence = (parseLocation) => {
    if (parseLocation.state && parseLocation.state.history)
        return { path: parseLocation.state.history.path, state: parseLocation.state.history.state };
    
    return null;
}

export const locationStateParse = (location) => {
    return location ? location.state : null;
}